import { CSSProperties } from "react";

export const maxDesktopGridSpan = 24;
export const maxTabletGridSpan = 12;

export const desktopColumns = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
  23, 24,
] as const;
export type ColNumber = typeof desktopColumns[number];
type GridColumnEnd = `span ${ColNumber}` | ColNumber | `${ColNumber}`;

export const tabletColumns = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] as const;
export type MEDColNumber = typeof tabletColumns[number];
type MEDGridColumnEnd =
  | `span ${MEDColNumber}`
  | MEDColNumber
  | `${MEDColNumber}`;

export const mobileColumns = [1, 2, 3, 4] as const;
export type SMLColNumber = typeof mobileColumns[number];
export type SMLGridColumnEnd =
  | `span ${SMLColNumber}`
  | SMLColNumber
  | `${SMLColNumber}`;

export interface ColumnProps {
  LRG:
    | {
        start?: ColNumber;
        end: GridColumnEnd;
        row?: CSSProperties["gridRow"];
      }
    | "hidden";
  MED:
    | {
        start?: MEDColNumber;
        end: MEDGridColumnEnd;
        row?: CSSProperties["gridRow"];
      }
    | "hidden";
  SML:
    | {
        start?: SMLColNumber;
        end: SMLGridColumnEnd;
        row?: CSSProperties["gridRow"];
      }
    | "hidden";
}
